import { createSlice } from '@reduxjs/toolkit';
import { GROUPBY } from '../../constants/Reports';

const csvBaseState = { data: null, filename: '' }

const baseObject = { data: {} };

const initialState = {
  payrollData: {},
  loading: false,
  ptoBalances: { data: [] },
  loadingpPtoBalances: false,
  callbackReportData: {},
  loadingCallbackReport: false,
  ptoReportData: {},
  loadingPtoReport: false,
  employeeList: [],
  loadingEmployeeList: false,
  csvPtoReport: csvBaseState,
  loadingCsvPtoReport: false,
  overtimeReportData: {},
  loadingOvertimeReport: false,
  payrollReportData: {},
  loadingPayrollReport: false,
  csvOvertimeReport: csvBaseState,
  loadingCsvOvertimeReport: false,
  overtimeListMasterReport: { FIRE: [], RESCUE: [] },
  isLoadingOvertimeListMasterReport: false,
  munisReportData: { outOfGrade: [], overtime: [], timeOff: [] },
  isMunisReportDataLoading: false,
  munisCsvReport: csvBaseState,
  isLoadingMunisCsvData: false,
  swapShiftsData: [],
  isLoadingSwapShifts: false,
  weeklyPayrollReportData: {},
  loadingWeeklyPayrollReport: false,
  weeklyPayrollCsvReport: csvBaseState,
  isLoadingWeeklyPayrollCsvData: false,
  adjustHours: {
    header: null,
    data: null,
    total: 0,
  },
  isLoadingAdjustHours: false,
  availabilityDetail: {
    header: [],
    data: {},
  },
  isLoadingAvailabilityDetail: false,
  availabilitySummary: {
    header: {},
    data: {},
  },
  isLoadingAvailabilitySummary: false,
  miltonReportData: { header: {}, data: {} },
  isLoadingMiltonReport: false,
  miltonCSVReportData: csvBaseState,
  isLoadingCSVMiltonReport: false,
  charltonReportData: { headers: {}, data: {} },
  isLoadingCharltonReport: false,
  charltonCSVReportData: csvBaseState,
  isLoadingCSVCharltonReport: false,
  woburnReportData: { data: {} },
  isWoburnReportDataLoading: false,
  woburnCSVData: csvBaseState,
  isWoburnCSVDataLoading: false,
  woburnOvertimeReportData: { overtime: { data: {} }, oog: { data: {} } },
  isWoburnOvertimeReportLoading: false,
  woburnOvertimeCSVReportData: csvBaseState,
  isLoadingCSVWoburnOvertimeReport: false,
	woburnReassignmentReportData: { headers: [], data: {} },
	isLoadingWoburnReassignmentReportData: false,
	CSVWoburnReassignmentReport: csvBaseState,
	isLoadingCSVWoburnReassignmentReport: false,
  woburnPTOdata: { headers: [], data: {} },
  isWoburnPTODataLoading: false,
  woburnPtoCSVData: csvBaseState,
  isWoburnPtoCSVDataLoading: false,
  woburnMunisPtoData: { data: {} },
  isWoburnMunisPtoDataLoading: false,
  woburnMunisPtoCSVData: csvBaseState,
  isWoburnMunisPtoCSVLoading: false,
  woburnMunisOvertimeReportData: {
      overtime: baseObject,
      town: baseObject,
      oog: baseObject,
      private: baseObject,
      stipends_os: baseObject,
      stipends_so: baseObject,
  },
  isWoburnMunisOvertimeReportDataLoading: false,
  woburnMunisOvertimeCSVReportData: csvBaseState,
  isWoburnMunisOvertimeCSVReportDataLoading: false,
  availableReports: {},
  isAvailableReportsLoading: null,
  ptoOptionsList: [],
  isPtoOptionsListLoading: false,
};

export const reportsDetails = createSlice({
  name: 'reportsDetails',
  initialState,
  reducers: {
    setAvailableReports: (state, action) => {
      state.availableReports = action.payload;
    },
    setIsAvailableReportsLoading: (state, action) => {
      state.isAvailableReportsLoading = action.payload;
    },
    setPtoOptionsList: (state, action) => {
      state.ptoOptionsList = action.payload
    },
    setIsLoadingPtoOptionsList: (state, action) => {
      state.isPtoOptionsListLoading = action.payload
    },
    setWeeklyPayrollReportData: (state, action) => {
      state.weeklyPayrollReportData = action.payload;
    },
    setLoadingWeeklyPayrollReport: (state, action) => {
      state.loadingWeeklyPayrollReport = action.payload;
    },
    clearWeeklyPayrollReportData: (state) => {
      state.weeklyPayrollReportData = {};
    },
    setPayrollData: (state, action) => {
      state.payrollData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPtoBalances: (state, action) => {
      state.ptoBalances = action.payload;
    },
    setLoadingPtoBalances: (state, action) => {
      state.loadingpPtoBalances = action.payload;
    },
    setCallbackReportData: (state, action) => {
      state.callbackReportData = action.payload;
    },
    setLoadingCallbackReport: (state, action) => {
      state.loadingCallbackReport = action.payload;
    },
    setPtoReportData: (state, action) => {
      state.ptoReportData = action.payload;
    },
    setLoadingPtoReport: (state, action) => {
      state.loadingPtoReport = action.payload;
    },
    clearPtoReportData: (state) => {
      state.ptoReportData = {};
    },
    setEmployeeList: (state, action) => {
      state.employeeList = Object.entries(action.payload)?.map((it) => ({
        name: it[1],
        id: it[0],
      }));
    },
    setLoadingEmployeeList: (state, action) => {
      state.loadingEmployeeList = action.payload;
    },
    setCsvPtoReport: (state, action) => {
      state.csvPtoReport = action.payload;
    },
    setLoadingCsvPtoReport: (state, action) => {
      state.loadingCsvPtoReport = action.payload;
    },
    clearCsvReportData: (state) => {
      state.csvPtoReport = csvBaseState;
    },
    setOvertimeReportData: (state, action) => {
      state.overtimeReportData = action.payload;
    },
    setLoadingOvertimeReport: (state, action) => {
      state.loadingOvertimeReport = action.payload;
    },
    clearOvertimeReportData: (state) => {
      state.overtimeReportData = null;
    },
    setPayrollReportData: (state, action) => {
      state.payrollReportData = action.payload;
    },
    setLoadingPayrollReport: (state, action) => {
      state.loadingPayrollReport = action.payload;
    },
    clearPayrollReportData: (state) => {
      state.payrollReportData = null;
    },
    setCsvOvertimeReport: (state, action) => {
      state.csvOvertimeReport = action.payload;
    },
    setLoadCsvOvertimeReport: (state, action) => {
      state.loadingCsvOvertimeReport = action.payload;
    },
    clearCsvOvertimeReportData: (state) => {
      state.csvOvertimeReport = csvBaseState;
    },
    setOvertimeListMasterReportData: (state, action) => {
      state.overtimeListMasterReport = action.payload.data;
    },
    setToggleLoadingOvertimeListMasterReportData: (state, action) => {
      state.isLoadingOvertimeListMasterReport = action.payload;
    },
    setMunisReportData: (state, action) => {
      const searchParams = new URLSearchParams(window.location.search);
      const groupByParam = searchParams.get('groupby') || GROUPBY[0].value;
      const unifyData = (obj) => {
        const result = [];

        for (const [key, value] of Object.entries(obj)) {
          groupByParam === GROUPBY[0].value
            ? result.push({
                name: key,
                items: value.map((item) => {
                  const [date, shift, type, hours] = item;
                  return { date, shift, type, hours: hours || '-' };
                }),
              })
            : result.push({
                name: key,
                items: value.map((item) => {
                  const [name, date, shift, type, hours] = item;
                  return { name, date, shift, type, hours: hours || '-' };
                }),
              });
        }

        return result;
      };

      const baseObj = {
        outOfGrade: unifyData(action.payload.out_of_grade),
        overtime: unifyData(action.payload.overtime),
        timeOff: unifyData(action.payload.time_off),
      };

      state.munisReportData = baseObj;
    },
    setIsLoadingMunisReportData: (state, action) => {
      state.isMunisReportDataLoading = action.payload;
    },
    setMunisReportCsvData: (state, action) => {
      state.munisCsvReport = action.payload;
    },
    setIsLoadingMunisCsvData: (state, action) => {
      state.isLoadingMunisCsvData = action.payload;
    },
    setSwapShiftsData: (state, action) => {
      const unifyData = (obj) => {
        const result = [];

        for (const [key, value] of Object.entries(obj)) {
          result.push({
            name: key,
            items: value.data.map((item) => {
              const [shift, fill, shiftType, filledBy, hours, status] = item;
              return {
                shift,
                fill,
                'shift-type': shiftType,
                'filled-by': filledBy,
                hours: hours || '-',
                status,
              };
            }),
          });
        }

        return result;
      };

      state.swapShiftsData = unifyData(action.payload.data);
    },
    setIsLoadingSwapShifts: (state, action) => {
      state.isLoadingSwapShifts = action.payload;
    },
    setWeeklyPayrollCsvData: (state, action) => {
      state.weeklyPayrollCsvReport = action.payload;
    },
    setIsLoadingWeeklyPayrollCsvData: (state, action) => {
      state.isLoadingWeeklyPayrollCsvData = action.payload;
    },
    setAdjustHours: (state, action) => {
      state.adjustHours = action.payload;
    },
    setIsLoadingAdjustHours: (state, action) => {
      state.isLoadingAdjustHours = action.payload;
    },
    clearAdjustHours: (state) => {
      state.ptoReportData = {};
      state.isLoadingAdjustHours = false;
    },
    setAvailabilityDetail: (state, action) => {
      state.availabilityDetail = action.payload;
    },
    setIsLoadingAvailabilityDetail: (state, action) => {
      state.isLoadingAvailabilityDetail = action.payload;
    },
    clearAvailabilityDetail: (state) => {
      state.availabilityDetail = {
        header: [],
        data: {},
      };
      state.isLoadingAvailabilityDetail = false;
    },
    setAvailabilitySummary: (state, action) => {
      state.availabilitySummary = action.payload;
    },
    setIsLoadingAvailabilitySummary: (state, action) => {
      state.isLoadingAvailabilitySummary = action.payload;
    },
    clearAvailabilitySummary: (state) => {
      state.availabilitySummary = {
        header: [],
        data: [],
      };
      state.isLoadingAvailabilitySummary = false;
    },
    setMiltonReportData: (state, action) => {
      state.miltonReportData = action.payload;
    },
    setIsLoadingMiltonReportData: (state, action) => {
      state.isLoadingMiltonReport = action.payload;
    },
    setCSVMiltonReportData: (state, action) => {
      state.miltonCSVReportData = action.payload;
    },
    setCSVIsLoadingMiltonReportData: (state, action) => {
      state.isLoadingCSVMiltonReport = action.payload;
    },
    setCharltonReportData: (state, action) => {
      state.charltonReportData = action.payload;
    },
    setLoadingCharltonReport: (state, action) => {
      state.isLoadingCharltonReport = action.payload;
    },
    setCSVCharltonReportData: (state, action) => {
      state.charltonCSVReportData = action.payload;
    },
    setCSVLoadingCharltonReport: (state, action) => {
      state.isLoadingCSVCharltonReport = action.payload;
    },
    setWoburnReportData: (state, action) => {
      state.woburnReportData = action.payload;
    },
    setLoadingWoburnMunisOvertimeReport: (state, action) => {
      state.isWoburnMunisOvertimeReportDataLoading = action.payload;
    },
    setWoburnMunisOvertimeCSVReportData: (state, action) => {
      state.woburnMunisOvertimeCSVReportData = action.payload;
    },
    setLoadingWoburnCSVReport: (state, action) => {
      state.isWoburnCSVDataLoading = action.payload;
    },
    setWoburnOvertimeReportData: (state, action) => {
      state.woburnOvertimeReportData = action.payload;
    },
    setLoadingWoburnOvertimeReport: (state, action) => {
      state.isWoburnOvertimeReportLoading = action.payload;
    },
    setCSVWoburnOvertimeReportData: (state, action) => {
      state.woburnOvertimeCSVReportData = action.payload;
    },
    setLoadingCSVWoburnOvertimeReport: (state, action) => {
      state.isLoadingCSVWoburnOvertimeReport = action.payload;
    },
		setWoburnReassignmentReportData: (state, action) => {
      state.woburnReassignmentReportData = action.payload;
    },
    setLoadingWoburnMunisPtoReport: (state, action) => {
      state.isWoburnMunisPtoDataLoading = action.payload;
    },
    setWoburnMunisPtoCSVReportData: (state, action) => {
      state.woburnMunisPtoCSVData = action.payload;
    },
		setIsLoadingCSVWoburnReassignmentReport: (state, action) => {
      state.isLoadingCSVWoburnReassignmentReport = action.payload;
    },
    setWoburnPTOReportData: (state, action) => {
      state.woburnPTOdata = action.payload;
    },
    setLoadingWoburnPTOReport: (state, action) => {
      state.isWoburnPTODataLoading = action.payload;
    },
    setWoburnPtoCSVReportData: (state, action) => {
      state.woburnPtoCSVData = action.payload;
    },
    setLoadingWoburnPtoCSVReport: (state, action) => {
      state.isWoburnPtoCSVDataLoading = action.payload;
    },
    setWoburnMunisPtoReportData: (state, action) => {
      state.woburnMunisPtoData = action.payload;
    },
    setLoadingWoburnMunisPtoReport: (state, action) => {
      state.isWoburnMunisPtoDataLoading = action.payload;
    },
    setWoburnMunisPtoCSVReportData: (state, action) => {
      state.woburnMunisPtoCSVData = action.payload;
    },
    setLoadingWoburnMunisPtoCSVReport: (state, action) => {
      state.isWoburnMunisPtoCSVLoading = action.payload;
    },
    setWoburnMunisOvertimeReportData: (state, action) => {
      state.woburnMunisOvertimeReportData = action.payload;
    },
    setLoadingWoburnMunisOvertimeReport: (state, action) => {
      state.isWoburnMunisOvertimeReportDataLoading = action.payload;
    },
		setCSVWoburnReassignmentReport: (state, action) => {
      state.CSVWoburnReassignmentReport = action.payload;
    },
    setLoadingWoburnMunisOvertimeCSVReport: (state, action) => {
      state.isWoburnMunisOvertimeCSVReportDataLoading = action.payload;
    },
  },
});

export const reportDetailsActions = reportsDetails.actions;

export default reportsDetails.reducer;
